var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8945 10.4728C71.1899 23.3824 71.5071 44.638 58.6088 57.9461C45.7048 71.2534 24.4765 71.5705 11.1813 58.6611C-2.10806 45.7512 -2.43108 24.4956 10.467 11.1877C23.3644 -2.11298 44.5991 -2.43036 57.8945 10.4728Z",
    fill: "#FEFEFE",
    stroke: "#FF8C0B",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8057 52.5114C29.9698 52.5114 26.0862 51.2558 26.0862 48.8562C26.0862 48.3452 26.2854 47.5854 27.2338 46.8628C27.5777 46.6005 28.0697 46.6665 28.3319 47.0066C28.5958 47.3485 28.5294 47.8375 28.1872 48.0981C27.988 48.2504 27.6526 48.5499 27.6526 48.8545C27.6526 49.7091 30.0481 50.9512 33.804 50.9512C37.5599 50.9512 39.9435 49.7091 39.9435 48.8545C39.9435 48.5499 39.6098 48.2504 39.4106 48.0981C39.0667 47.8358 39.002 47.3468 39.2659 47.0066C39.5298 46.6648 40.0218 46.6005 40.3641 46.8628C41.3124 47.5854 41.5116 48.3452 41.5116 48.8562C41.5116 51.2304 37.5395 52.5114 33.804 52.5114H33.8057ZM33.8057 47.9289C33.7376 47.9289 33.6712 47.9204 33.6048 47.9018C32.0861 47.5024 23.563 40.0533 23.563 31.3063C23.563 25.6966 28.1583 21.1327 33.8057 21.1327C39.4532 21.1327 44.0365 25.6966 44.0365 31.3063C44.0365 40.055 35.5219 47.5041 34.0066 47.9035C33.9402 47.9204 33.8738 47.9306 33.8057 47.9306V47.9289ZM33.8057 22.6912C29.0232 22.6912 25.1311 26.5562 25.1311 31.3063C25.1311 38.8062 32.1304 45.2264 33.8057 46.279C35.4794 45.2264 42.4702 38.8079 42.4702 31.3063C42.4702 26.5562 38.5832 22.6912 33.8074 22.6912H33.8057ZM33.8057 36.3355C31.0169 36.3355 28.7473 34.0798 28.7473 31.3063C28.7473 28.5327 31.0169 26.2889 33.8057 26.2889C36.5945 26.2889 38.8522 28.5395 38.8522 31.3063C38.8522 34.073 36.5877 36.3355 33.8057 36.3355ZM33.8057 27.8457C31.8801 27.8457 30.3154 29.3975 30.3154 31.3046C30.3154 33.2117 31.8818 34.7753 33.8057 34.7753C35.7296 34.7753 37.2841 33.2185 37.2841 31.3046C37.2841 29.3907 35.7245 27.8457 33.8057 27.8457Z",
    fill: "#FF8C0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4735,
    height: 31.3787,
    fill: "white",
    transform: "translate(23.563 21.1327)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1On);
export default __webpack_public_path__ + "static/media/1_on.cbf1ff3654b5b496aac825c922f77177.svg";
export { ForwardRef as ReactComponent };